import React, { Component } from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { TimelineMax } from 'gsap/all'
import { theme, media } from '../../styles'

const { fonts, fontSizes } = theme

const Container = styled.div`
  width: 35vw;
  height: 100%;
  ${media.tablet`
    width: 50vw;
  `}
`

const Grid = styled.div`
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: grid;
  grid-template-columns: 12.5% 12.5% 12.5% 12.5% 12.5% 12.5% 12.5% 12.5%;
  grid-template-rows: repeat(6, 1fr);
  transition: opacity 0.5s ease 0.5s;
`

const FeaturedTitle = styled.h4.attrs(({
  shade,
  columnstart,
  columnend,
  rowstart,
  rowend
}) => ({
  color: shade || '#FFFFFF',
  columnstart: columnstart || 1,
  columnend: columnend || 7,
  rowstart: rowstart || 2,
  rowend: rowend || 5,
}))`
  opacity: 0;
  grid-column-start: ${props => props.columnstart};
  grid-column-end: ${props => props.columnend};
  grid-row-start: ${props => props.rowstart};
  grid-row-end: ${props => props.rowend};
  align-self: flex-end;
  z-index: 3;
  color: ${props => props.color};
  font-family: ${fonts.accent};
  font-size: ${fontSizes.title};
  font-weight: 100;
  margin: 0 0 0 -15px;
`

const FeaturedImage = styled.div.attrs(({
  columnstart,
  columnend,
  rowstart,
  rowend
}) => ({
  columnstart: columnstart || 1,
  columnend: columnend || 7,
  rowstart: rowstart || 2,
  rowend: rowend || 5,
}))`
  opacity: 0;
  grid-column-start: ${props => props.columnstart};
  grid-column-end: ${props => props.columnend};
  grid-row-start: ${props => props.rowstart};
  grid-row-end: ${props => props.rowend};
  align-self: flex-end;
`

const StyledImage = styled(Img).attrs(({
  shade
}) => ({
  color: shade || '#FFFFFF',
}))`
  // &:hover,
  // &:focus {
    transition-property: box-shadow;
    transition-duration: 0.2s;
    transition-timing-function: ease;
    transition-delay: 0s;
    box-shadow: 20px 20px 0 ${props => props.color};
  // }
`

export default class FeaturedItem extends Component {
  static contextTypes = {
    scrollmagic: PropTypes.any,
  }

  constructor(props) {
    super(props)

    this.item = null
    this.image = null
    // this.title = null
    this.animation = new TimelineMax({ paused: true })
  }

  componentDidMount() {
    const { scrollMagic } = this.props
    const { Scene } = scrollMagic

    this.animation
      .set(this.item, { css: { animation: 'none' } })
      .set(this.image, { x: '-100%' })
      .to(this.image, 0.3, {
        ease: 'Sine.easeOut',
        x: '0%'
      }, 'begin')
      .to(this.image, 0.2, { opacity: 1 }, 'begin+=0.2')
      // .to(this.title, 1, {
      //   opacity: 1,
      //   x: -3,
      //   ease: 'Power0.easeNone'
      // }, 'start+=0.5')
      .to(this.image, 0.7, { scale: 1, ease: 'Linear.easeNone' }, 'start')

    this.scene = new Scene({
      triggerElement: this.item,
      triggerHook: 0.8
    })

    this.scene.on('enter', () => {
      this.animation.play()
      if (this.props.index === 3) {
        this.props.hideScroll()
      }
    })

    this.scene.addTo(this.context.scrollmagic)
  }

  getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max))
  }

  render() {
    const { frontmatter, shadowColor } = this.props

    const {
      name,
      // link,
      image,
      columnstart,
      columnend,
      rowstart,
      rowend
    } = frontmatter
    return (
      <Container>
        <Grid ref={c => { this.item = c }}>
          <FeaturedImage
            ref={c => { this.image = c }}
            columnstart={columnstart}
            columnend={columnend}
            rowstart={rowstart}
            rowend={rowend}
          >
            <StyledImage
              shade={shadowColor}
              fluid={image.childImageSharp.fluid}
            />
          </FeaturedImage>
          {/* <FeaturedTitle
            ref={c => { this.title = c }}
            columnstart={columnstart}
            columnend={columnend}
            rowstart={rowstart}
            rowend={rowend}
            shade={theme.colors.text}
          >
            {name}
          </FeaturedTitle> */}
        </Grid>
      </Container>
    )
  }
}
